import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import i18n from '@/lang/i18n';
import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import Role from '@/types/SelfRole';
import { onMounted, ref, computed } from 'vue';
import SelectRoleChecker from '@/router/selectRoleChecker';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserRoleAutoComplete',
  props: {
    modelValue: {},
    initialRoleId: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const items = ref<Role[]>([]);

onMounted(() => {
  SelectRoleChecker
    .getSelfRoles()
    .then((data) => {
      items.value = data;
      setModelValue()
    });
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const setModelValue = () => {
  let filteredItems = items.value;
  modelValue.value = filteredItems.filter((item) => {
    return item.id === props.initialRoleId
  })[0];
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithSingleSelectedItem, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    label: _unref(i18n).global.t('pages.selectRole.selectRoleLabel'),
    itemName: "organization_name",
    items: items.value,
    "initial-item-id": props.initialRoleId,
    errorMessages: props.errorMessages,
    clearable: false,
    selectFirstIfOnlyOne: ""
  }, null, 8, ["modelValue", "label", "items", "initial-item-id", "errorMessages"]))
}
}

})